module.exports = __webpack_public_path__ + "static/media/left-arrow.6bc716ca.png";